import Keycloak from 'keycloak-js';

const getKeycloakConfigFile = () => {
    const host = window.location.hostname;
    if (host.includes('localhost') || host.includes('int')) return '/keycloak-conf-test-alm.json';

    return '/keycloak-conf-test-alm.json';
};

const kc = new Keycloak(process.env.PUBLIC_URL + getKeycloakConfigFile());

const doLogin = kc.login;

const doLogout = kc.logout;

const getToken = () => kc.token;

const isLoggedIn = () => !!kc.token;

const updateToken = (successCallback) => kc.updateToken(5)
    .then(successCallback)
    .catch(doLogin);

const getUsername = () => kc.tokenParsed?.preferred_username;
const getEmail = () => kc.tokenParsed?.email;

const hasRole = (role, client = "licence-manager") => {
    const resourceAccess = kc?.resourceAccess || {};
    const clientRoles = resourceAccess[client]?.roles || [];
    return clientRoles.includes(role);
};

const getTokenParsed = kc.tokenParsed;

const getNameSurnameInitials = () => `${kc.tokenParsed?.given_name[0]}${kc.tokenParsed?.family_name[0]}`;

const getInstance = kc;

/**
 * Initializes Keycloak instance and calls the provided
 * callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
const initKeycloak = (onAuthenticatedCallback) => {
    kc.init({
        promiseType: 'native',
        onLoad: 'check-sso',
        flow: 'standard',
        checkLoginIframe: false,
        redirectUri: process.env.PUBLIC_URL,
    })
        .then((authenticated) => {
            if (authenticated) {
                onAuthenticatedCallback();
            } else {
                doLogin();
            }
        });
};

const KeycloakService = {
    initKeycloak,
    doLogin,
    doLogout,
    isLoggedIn,
    getToken,
    updateToken,
    getUsername,
    getEmail,
    hasRole,
    getTokenParsed,
    getInstance,
    getNameSurnameInitials,
};

export default KeycloakService;
